import { render, staticRenderFns } from "./ScrollBar.vue?vue&type=template&id=d850537e&scoped=true"
import script from "./ScrollBar.vue?vue&type=script&lang=ts"
export * from "./ScrollBar.vue?vue&type=script&lang=ts"
import style0 from "./ScrollBar.vue?vue&type=style&index=0&id=d850537e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d850537e",
  null
  
)

export default component.exports